// delLists/draftLists/actions.js

import { getDelLists } from "../../../api/DelApi";
import { draftsInitialState } from "./delListsDraftsListsState";
import { filtersInitialState } from "../../shared/filters/filtersState";
export const makeDraftsActions = (set, get) => ({
  setDraftsPage: ({ currentPage, pageSize }) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        drafts: { ...s.delLists.drafts, currentPage, pageSize },
      },
    })),

  setDraftsPageSize: (pageSize) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        drafts: { ...s.delLists.drafts, pageSize, currentPage: 1 },
      },
    })),

  setSelectedDraft: (draft) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        drafts: { ...s.delLists.drafts, selectedDraft: draft },
      },
    })),

  deleteDraftLocal: (id) =>
    set((s) => {
      const items = s.delLists.drafts.items.filter((d) => d.id !== id);
      const totalCount =
        s.delLists.drafts.totalCount > 0 ? s.delLists.drafts.totalCount - 1 : 0;
      return {
        delLists: {
          ...s.delLists,
          drafts: { ...s.delLists.drafts, items, totalCount },
        },
      };
    }),

  // Insert or update a draft row locally without refetching
  upsertDraftLocal: (row) =>
    set((s) => {
      const items = [...s.delLists.drafts.items];
      const idx = items.findIndex((d) => d.id === row.id);
      if (idx >= 0) {
        // Update in place to avoid reordering on autosave
        items[idx] = { ...items[idx], ...row };
      } else {
        items.unshift(row);
      }
      const totalCount =
        idx >= 0
          ? s.delLists.drafts.totalCount
          : s.delLists.drafts.totalCount + 1;
      return {
        delLists: {
          ...s.delLists,
          drafts: { ...s.delLists.drafts, items, totalCount },
        },
      };
    }),

  // Move a draft into submits locally after successful submission
  moveDraftToSubmitsLocal: (row) =>
    set((s) => {
      // Remove from drafts
      const dItems = s.delLists.drafts.items.filter((d) => d.id !== row.id);
      const dCount = Math.max(
        0,
        (s.delLists.drafts.totalCount || 0) -
          (s.delLists.drafts.items.some((d) => d.id === row.id) ? 1 : 0)
      );

      // Upsert into submits at the top
      const sItems = [...(s.delLists.submits.items || [])];
      const sIdx = sItems.findIndex((d) => d.id === row.id);
      if (sIdx >= 0) {
        sItems[sIdx] = { ...sItems[sIdx], ...row };
      } else {
        sItems.unshift(row);
      }
      const sCount =
        sIdx >= 0
          ? s.delLists.submits.totalCount
          : (s.delLists.submits.totalCount || 0) + 1;

      return {
        delLists: {
          ...s.delLists,
          drafts: { ...s.delLists.drafts, items: dItems, totalCount: dCount },
          submits: { ...s.delLists.submits, items: sItems, totalCount: sCount },
        },
      };
    }),

  resetDrafts: () =>
    set((s) => ({ delLists: { ...s.delLists, drafts: draftsInitialState } })),

  fetchDraftsPage: async (employeeId, overrideFilters) => {
    const {
      delLists: {
        drafts: { currentPage, pageSize, filters, tableType },
      },
    } = get();
    const activeFilters = overrideFilters || filters || filtersInitialState();

    set((s) => ({
      delLists: {
        ...s.delLists,
        drafts: { ...s.delLists.drafts, loading: true, error: null },
      },
    }));

    try {
      const r = await getDelLists(
        employeeId,
        tableType,
        currentPage,
        pageSize,
        activeFilters
      );
      set((s) => ({
        delLists: {
          ...s.delLists,
          drafts: {
            ...s.delLists.drafts,
            loading: false,
            items: r.del_list,
            totalCount: r.total_count,
            needsUpdate: false,
            selectedDraft: null,
          },
        },
      }));
    } catch (err) {
      console.error("Failed to fetch drafts page:", err);
      set((s) => ({
        delLists: {
          ...s.delLists,
          drafts: { ...s.delLists.drafts, loading: false, error: err.message },
        },
      }));
    }
  },
});
